module.exports = __webpack_public_path__ + "22_nips.jpg?cf3c53b3ef0aebd098733269b8f1a6a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_nips.jpg
// module id = 187
// module chunks = 0